module.exports = __webpack_public_path__ + "static/media/clinician-cover-cloud.1dbbaa53.svg";